import { SignalKey } from "@/types/IProjects";

export const signalNames: Record<SignalKey, string> = {
  technical: "Technical",
  authority: "Authority",
  brand: "Brand",
};

export const signalDescription: Record<SignalKey, string> = {
  technical: "These are the non-negotiable, foundational signals that every trustworthy website must have to be taken seriously by AI and users.",
  authority: "These powerful signals elevate your brand from being merely present online to being seen as a credible, authoritative, and expert source.",
  brand: "These are advanced, professional-grade signals that enhance the user experience and set you apart as a best-in-class brand.",
};
